export default {
  brand: "BasetaoSheet",
  nav: {
    spreadsheet: "Spreadsheet",
    guides: "Guías",
    categories: "Categorías",
    review: "Reseña",
    shipping: "Envío",
    home: "Inicio",
    faq: "FAQ",
    shoppingGuide: "Guía de compra",
    visitMain: "Visitar el sitio principal",
  },
  search: {
    placeholder: "Buscar Basetao Spreadsheet, vendedores, envío...",
  },
  cta: {
    basetaoSpreadsheet: "Basetao Spreadsheet",
    buyNow: "Comprar ahora",
    visitMain: "Visitar el sitio principal",
    explore: "Explorar",
  },
  lang: {
    label: "Idioma",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  },
  notFound: {
    title: "Página no encontrada",
    subtitle: "Lo sentimos, la página que buscas no existe o puede haber sido movida.",
    backHome: "Volver al inicio",
  },
  categories: {
    title: "Explorar categorías de productos",
    subtitle: "Descubre cada grupo de productos cubierto por el spreadsheet, cada uno enlazado al catálogo principal.",
    shoes: "Zapatos",
    hoodies: "Sudaderas / Suéteres",
    tshirts: "Camisetas",
    jackets: "Chaquetas",
    pants: "Pantalones / Shorts",
    headwear: "Gorras / Sombreros",
    sets: "Conjuntos",
    underwear: "Ropa interior",
    jersey: "Camisetas deportivas",
    accessories: "Accesorios",
    bags: "Bolsos",
    belts: "Cinturones",
    perfumes: "Perfumes",
    other: "Otros artículos",
    empty: "Ninguna categoría coincide con tu búsqueda.",
  },
  footer: {
    tagline: "Un centro de recursos independiente para guías, vendedores, envíos, cupones y consejos de seguridad de Basetao Spreadsheet.",
    resources: "Recursos",
    quickLinks: "Enlaces rápidos",
    disclaimer: "Este sitio es un recurso informativo independiente y no está afiliado a Basetao. Los enlaces de productos conducen al sitio principal.",
    copyright: "© 2026 BasetaoSheet. Todos los derechos reservados.",
    privacy: "Privacidad",
    terms: "Términos",
    contact: "Contacto",
  },
};